<div class="container-graphs">
  <div
    [id]="elId"
    *ngIf="!noTypesData"
    style="
      background: white;
      border-radius: 16px;
      display: flex;
      flex-direction: column-reverse;
    "
  >
    <div
      class="graph-title"
      style="display: flex; gap: 10px; padding-left: 20px; padding-top: 20px"
    >
      <h1>Tipos de ocorrência</h1>
      <button
        mat-icon-button
        #tooltip="matTooltip"
        matTooltip="Gráfico com os números de casos para cada tipo de agressão mapeada nos registros da NINA."
        matTooltipPosition="below"
        matTooltipHideDelay="100"
        aria-label="Button that displays a tooltip that hides when scrolled out of the container"
        class="info-icon"
      >
        <img src="assets/icons/questionTooltip.svg" alt="" />
      </button>
    </div>
  </div>

  <div
    style="
      background: white;
      border-radius: 16px;
      display: flex;
      flex-direction: column-reverse;
    "
    *ngIf="noTypesData"
  >
    <div
      class="graph-title"
      style="
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding-left: 20px;
        padding-top: 20px;
      "
    >
      <div class="d-flex flex-row">
        <h1>Tipos de ocorrência</h1>
        <button
          style="margin-left: 10px"
          mat-icon-button
          #tooltip="matTooltip"
          matTooltip="Gráfico com os números de casos para cada tipo de agressão mapeada nos registros da NINA."
          matTooltipPosition="below"
          matTooltipHideDelay="100"
          aria-label="Button that displays a tooltip that hides when scrolled out of the container"
          class="info-icon"
        >
          <img src="assets/icons/questionTooltip.svg" alt="" />
        </button>
      </div>

      <div
        style="
          width: 100%;
          height: 300px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          border-radius: 16px;
          border: 2px dashed #c8bfff;

          color: #ab9fff;

          font-size: 1rem;
          font-weight: 400;
        "
      >
        <p>Não há dados suficientes para gerar o gráfico.</p>
      </div>
    </div>
  </div>

  <div class="half-graph sublocality-half-graph">
    <div class="graph">
      <div class="graph-title">
        <h1>Ocorrências por bairro</h1>
        <button
          mat-icon-button
          #tooltip="matTooltip"
          matTooltip="Mapeamento dos bairros com mais ocorrências recebidas."
          matTooltipPosition="below"
          matTooltipHideDelay="100"
          aria-label="Button that displays a tooltip that hides when scrolled out of the container"
          class="info-icon"
        >
          <img src="assets/icons/questionTooltip.svg" alt="" />
        </button>
      </div>
      <canvas
        [id]="elId + 'myChartCasesPerSublocality'"
        style="max-height: 300px"
        *ngIf="!noSublocalityData"
      ></canvas>
      <div
        *ngIf="!noSublocalityData"
        style="
          width: 100%;
          display: flex;
          gap: 30px;
          flex-wrap: wrap;
          justify-content: center;
          margin-top: 20px;
        "
      >
        <div
          *ngFor="let color of dataSetOfsublocality"
          style="display: flex; gap: 10px"
        >
          <div
            [style.background]="color.backgroundColor"
            style="width: 16px; height: 16px; border-radius: 4px"
          ></div>
          <p
            style="
              color: var(--material-theme-ref-neutral-neutral-60, #938f94);
              font-family: Roboto;
              font-size: 12px;
              font-style: normal;
              margin: 0;
              font-weight: 400;
              line-height: 16px;
            "
          >
            {{ color.label }}
          </p>
        </div>
      </div>

      <div
        *ngIf="noData"
        style="
          width: 100%;
          height: 300px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          border-radius: 16px;
          border: 2px dashed #c8bfff;

          color: #ab9fff;

          font-size: 1rem;
          font-weight: 400;
        "
      >
        <p>Não há dados suficientes para gerar o gráfico.</p>
      </div>
    </div>
    <div class="graph">
      <div class="graph-title" style="padding-bottom: 0px">
        <h1>Termos frequentes</h1>
        <button
          mat-icon-button
          #tooltip="matTooltip"
          matTooltip="Palavras mais citadas nas descrições das ocorrências."
          matTooltipPosition="below"
          matTooltipHideDelay="100"
          aria-label="Button that displays a tooltip that hides when scrolled out of the container"
          class="info-icon"
        >
          <img src="assets/icons/questionTooltip.svg" alt="" />
        </button>
      </div>

      <ng-tag-cloud
        *ngIf="!noData"
        style="
          width: 100%;
          height: 300px;
          margin: 0 auto;
          margin-top: 40px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        "
        [config]="optionsCloud"
        [data]="dataCloud"
      ></ng-tag-cloud>

      <div
        *ngIf="noData"
        style="
          width: 100%;
          height: 300px;
          margin: 0 auto;
          margin-top: 40px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          border-radius: 16px;
          border: 2px dashed #c8bfff;

          color: #ab9fff;

          font-size: 1rem;
          font-weight: 400;
        "
      >
        <p>Não há dados suficientes para gerar o gráfico.</p>
      </div>
    </div>
  </div>
</div>
